import tryLoadMoreUponRowRemove from '../actions/table/tryLoadMoreUponRowRemove';
import selectNewItemUponRowRemoval from '../actions/triage/helpers/selectNewItemUponRowRemoval';
import removeRowsFromListViewStore from 'owa-mail-actions/lib/triage/removeRowsFromListViewStore';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import TableOperations from 'owa-mail-list-table-operations';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { createLazyOrchestrator } from 'owa-bundling';
import updateTableCurrentLoadedIndex from '../actions/table/updateTableCurrentLoadedIndex';

/**
 * Removes the given row from the list view store and selects the next row if needed.
 * @param rowKeys - the conversations to remove
 * @param tableView - the table to remove them from
 */
export default createLazyOrchestrator(
    removeRowsFromListViewStore,
    'clone_removeRowsFromListViewStore',
    actionMessage => {
        const { rowKeys, tableView } = actionMessage;

        // We want to keep focus where the user is currently triaging things.
        // So here we need to select the next row if the current row being removed is part of the selected rows.
        let rowIndex = -1;
        let lastSelectedRowWasPinned = false;

        const collectionLength = rowKeys.length;

        for (let i = 0; i < collectionLength; i++) {
            const rowKey = rowKeys[i];

            // Store the index of the selectedRowKey
            if (tableView.selectedRowKeys.has(rowKey)) {
                rowIndex = tableView.rowKeys.indexOf(rowKey);

                // Keep track of the pinned status of the row before we remove it below. We'll
                // use it to make a decision on selecting the appropriate row upon removal
                if (rowIndex > -1) {
                    lastSelectedRowWasPinned = MailRowDataPropertyGetter.getIsPinned(
                        tableView.rowKeys[rowIndex],
                        tableView
                    );
                }
            }

            // Remove the row from the list view store
            TableOperations.removeRow(rowKey, tableView);
        }

        // Update currentLoadedIndex so that it's not greater than the rows we have
        updateTableCurrentLoadedIndex(
            tableView.id,
            Math.min(tableView.currentLoadedIndex, tableView.rowKeys.length)
        );

        // Load more as needed since we removed some rows from view
        tryLoadMoreUponRowRemove(tableView);

        // Follow through with selecting the next row if
        // 1. There is next row present AND
        // 2. Folder is not the junk folder
        if (rowIndex > -1 && tableView.tableQuery.folderId != folderNameToId('junkemail')) {
            selectNewItemUponRowRemoval(tableView, rowIndex, lastSelectedRowWasPinned);
        }
    }
);
